import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getSTANDARDGRNHISTORYTableStructure";
export const UPDATE_TABLE_DATA = "getSTANDARDGRNHISTORYTableData";
export const EXPORT_TABLE_DATA = "exportSTANDARDGRNHISTORYTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setSTANDARDGRNHISTORYTableStructure";
export const SET_TABLE_DATA = "setSTANDARDGRNHISTORYTableData";
export const SET_TABLE_FILTER = "setSTANDARDGRNHISTORYTableFilter";
export const SET_TABLE_PAGE = "setSTANDARDGRNHISTORYTablePage";
export const SET_TABLE_PERPAGE = "setSTANDARDGRNHISTORYTablePerPage";
export const SET_TABLE_SORTBY = "setSTANDARDGRNHISTORYTableSortBy";
export const SET_TABLE_SORTORDER = "setSTANDARDGRNHISTORYTableSortOrder";

const state = {
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  /**
   * for table title, descripton
   * */
  getSTANDARDGRNHISTORYTableProperties(state) {
    return state.table_structure.properties;
  },
  /**
   * for table permissions
   **/
  getSTANDARDGRNHISTORYTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getSTANDARDGRNHISTORYTableState(state) {
    // console.log("table state is ", state.table_state);
    return state.table_state;
  },

  getSTANDARDGRNHISTORYTableHeaders(state) {
    return state.table_structure.columns;
  },

  getSTANDARDGRNHISTORYTableFilters(state) {
    return state.table_structure.filters;
  },

  getSTANDARDGRNHISTORYTableData(state) {
    return state.table_data.data;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    // console.log(payload);
    return new Promise((resolve) => {
      ApiService.post(
        "/warehouse_management/custom/standard_grn/standard_grn_history"
      )
        .then(({ data }) => {
          // console.log("suc", data);
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      // ApiService.post("login", credentials)
      ApiService.post(
        "/warehouse_management/custom/standard_grn/standard_grn_history/datatable",
        payload
      )
        .then(({ data }) => {
          // console.log("data of datatable ", data);
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
